// Formularios de contacto/presupuesto: envío sin recargar → Odoo (Cloudflare Worker) + copia por email de Shopify,
// y mensaje de confirmación en el sitio del formulario. Si Odoo falla, se hace el envío normal de Shopify.
(function () {
  var url = window.DK_ODOO_ENDPOINT;
  if (!url) return;
  var SEL = 'form#ContactForm, form#DkCtaForm, form.dk-quote__form, form.main_contact_form';
  var lang = (document.documentElement.lang || 'es').slice(0, 2);
  var T = {
    es: { sending: 'Enviando…', title: 'Gracias{n}, hemos recibido tu solicitud', text: 'Nuestro equipo la revisará y te contactará en 24-48 h laborables.', again: 'Enviar otra consulta', err: 'No se ha podido enviar. Inténtalo de nuevo.' },
    en: { sending: 'Sending…', title: 'Thank you{n}, we have received your request', text: 'Our team will review it and get back to you within 1-2 business days.', again: 'Send another enquiry', err: 'It could not be sent. Please try again.' },
    pt: { sending: 'A enviar…', title: 'Obrigado{n}, recebemos o seu pedido', text: 'A nossa equipa irá analisá-lo e contactá-lo em 24-48 h úteis.', again: 'Enviar outro pedido', err: 'Não foi possível enviar. Tente novamente.' }
  }[lang] || null;
  if (!T) T = { sending: 'Enviando…', title: 'Gracias{n}, hemos recibido tu solicitud', text: 'Nuestro equipo la revisará y te contactará en 24-48 h laborables.', again: 'Enviar otra consulta', err: 'No se ha podido enviar. Inténtalo de nuevo.' };

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function done(f, fd) {
    var name = (fd.get('contact[Nombre]') || fd.get('contact[name]') || '').trim().split(' ')[0];
    var box = document.createElement('div');
    box.className = 'dk-sent';
    box.setAttribute('role', 'status');
    box.setAttribute('tabindex', '-1');
    box.innerHTML =
      '<svg class="dk-sent__icon" viewBox="0 0 48 48" aria-hidden="true"><circle cx="24" cy="24" r="22" fill="none" stroke="currentColor" stroke-width="2"/><path d="M14 24.5l7 7 13-14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '<p class="dk-sent__title">' + esc(T.title.replace('{n}', name ? ', ' + name : '')) + '</p>' +
      '<p class="dk-sent__text">' + esc(T.text) + '</p>' +
      '<button type="button" class="dk-sent__again">' + esc(T.again) + '</button>';
    f.hidden = true;
    f.parentNode.insertBefore(box, f.nextSibling);
    box.focus({ preventScroll: true });
    var r = box.getBoundingClientRect();
    if (r.top < 0 || r.top > window.innerHeight * 0.7) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    box.querySelector('.dk-sent__again').addEventListener('click', function () {
      f.reset(); f.hidden = false; box.remove();
      var i = f.querySelector('input:not([type=hidden]),textarea'); if (i) i.focus();
    });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches(SEL) || f.__dkNative) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (f.__dkBusy) return;
    if (f.reportValidity && !f.reportValidity()) return;
    f.__dkBusy = true;
    var btn = f.querySelector('[type=submit]'), label = btn && btn.innerHTML;
    if (btn) { btn.disabled = true; btn.textContent = T.sending; }
    f.querySelectorAll('.dk-sent__err').forEach(function (x) { x.remove(); });

    var fd = new FormData(f);
    if (!fd.get('contact[URL]')) fd.append('contact[Página]', location.href);
    fd.append('contact[Idioma]', document.documentElement.lang || '');

    fetch(url, { method: 'POST', body: fd, mode: 'cors' })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok || !j.ok) throw new Error(j.error || r.status); }); })
      .then(function () {
        // Copia por email de Shopify (como antes), sin bloquear el mensaje
        try { fetch(f.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(f), credentials: 'same-origin', keepalive: true }).catch(function () {}); } catch (x) {}
        f.__dkBusy = false;
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        done(f, fd);
        f.dispatchEvent(new CustomEvent('dk:sent', { bubbles: true }));
      })
      .catch(function () {
        // Odoo no disponible: envío normal de Shopify para no perder la solicitud
        f.__dkNative = true;
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        f.dispatchEvent(new CustomEvent('dk:sent', { bubbles: true, detail: { native: true } }));
        HTMLFormElement.prototype.submit.call(f);
      });
  }, true);
})();
